import React from "react";
import { Navigate, useNavigate } from "react-router-dom";

import ConsentPage from "../../components/auth/ConsentPage";
import { useAuth } from "../../context/AuthContext";

// Post-signup Ley 1581 consent step. Reachable only while `pendingConsentData`
// is set (right after athlete sign-up); on a fresh session there is nothing to
// consent to, so we bounce to the dashboard.
const ConsentRoute = () => {
  const navigate = useNavigate();
  const { pendingConsentData, completeConsent } = useAuth();

  if (!pendingConsentData) {
    return <Navigate to="/athlete/dashboard" replace />;
  }

  return (
    <ConsentPage
      athleteId={pendingConsentData.athleteId}
      isMinor={pendingConsentData.isMinor}
      guardianEmail={pendingConsentData.guardianEmail}
      onComplete={() => {
        completeConsent();
        navigate("/athlete/onboarding", { replace: true });
      }}
    />
  );
};

export default ConsentRoute;
